import React, { useEffect, useState } from 'react';
import styles from '../../../../Secure.module.scss';
import { Methods, useFetch } from '../../../../../../hooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { ComponentLoader } from '../../../../../../components/ComponentLoader';
import { CollapsableLeagueCard } from '../../CollapsableLeagueCard';
import { Fixture, League } from '../../../../../../types/DbModels';
import { FixtureDetails } from '../../../../fixture/FixtureDetails';

export const Top: React.FC = () => {
   const [topLeagues, setTopLeagues] = useState<Array<League>>([]);
   const [fixtures, setFixtures] = useState<Array<Fixture>>([]);
   const [fixture, setFixture] = useState<Fixture | null | undefined>(null);
   const [isLoading, setIsLoading] = useState(true);

   const params = useParams();
   const navigate = useNavigate();

   const { makeRequest: fetchTopLeagues } = useFetch(
      `/api/top/fixtures`,
      {
         method: Methods.GET
      },
      true
   );

   const handleUpdateTopLeagues = (leagueToUpdate: League) => {
      const updatedLeagues = topLeagues.map((league: League) => {
         if (league.id === leagueToUpdate.id) {
            return { ...league, collapsed: !league.collapsed };
         }

         return league;
      });

      setTopLeagues(updatedLeagues);
   };

   const handleFetchTopLeagues = async () => {
      const { data: response } = await fetchTopLeagues();

      setTopLeagues(response.data.leagues);
      setFixtures(response.data.fixtures);
      setIsLoading(false);
      setFixture(null);
   };

   const handleRefetchLeague = async (leagueId: number | null = null) => {
      const { data: response } = await fetchTopLeagues(leagueId ? { params: { id: leagueId } } : {});

      const leagueIndex = topLeagues.findIndex((favoriteLeague: League) => favoriteLeague.id === leagueId);

      const newlyFetchedLeague: League = response.data.leagues[0];

      if (leagueIndex > -1) {
         newlyFetchedLeague.collapsed = topLeagues[leagueIndex].collapsed;

         topLeagues.splice(leagueIndex, 1);
      }

      setTopLeagues([...topLeagues, ...[newlyFetchedLeague]]);

      const newFixtures = fixtures.filter((fixture) => fixture.league_id !== leagueId);

      setFixtures([...newFixtures, ...response.data.fixtures]);

      setFixture(null);
   };
   useEffect(() => {
      handleFetchTopLeagues();
   }, []);

   useEffect(() => {
      if (params && params.id) {
         const currentFixture: Fixture | null | undefined = fixtures.find(
            (f: Fixture) => f.id === (params.id ? parseInt(params.id) : null)
         );

         if (currentFixture) {
            setFixture(currentFixture);
            return;
         }
      } else if (fixture) {
         handleRefetchLeague(fixture.league_id);
      }
   }, [params.id]);

   const handleRenderFavoriteLeagues = () => {
      if (isLoading) {
         return <ComponentLoader isLoading />;
      }

      if (!topLeagues.length) {
         return (
            <div
               onClick={() => navigate(`/matches/all`)}
               style={{
                  textAlign: 'center',
                  fontSize: '20px',
                  color: '#FFF',
                  fontWeight: 'bold'
               }}
            >
               No top leagues with active matches found!
            </div>
         );
      }

      if (fixture) {
         return <FixtureDetails fixture={fixture} />;
      }

      return (
         <>
            {topLeagues.map(
               (
                  { logo, name, fixtures_count, country_name, favorite, id, fixtures, collapsed }: any,
                  index: number
               ) => {
                  return (
                     <CollapsableLeagueCard
                        key={index}
                        id={id}
                        favorite={Boolean(favorite)}
                        logo={logo}
                        name={name}
                        fixtures_count={fixtures_count}
                        fixtures={fixtures}
                        country_name={country_name}
                        collapsed={collapsed}
                        updateParent={handleUpdateTopLeagues}
                     />
                  );
               }
            )}
         </>
      );
   };

   return <div className={styles.favoritesWrapper}>{handleRenderFavoriteLeagues()}</div>;
};
